export default "__VITE_PUBLIC_ASSET__8d2a5257__"